import CouponCreateContainer from "./CouponCreateContainer"


const CouponCreate = () => {
  return (
    <div className='page-body'>
      <CouponCreateContainer />
    </div>
  )
}

export default CouponCreate